import { Editor, Transforms, Node, Element, Text } from 'slate';
import NormalizeTopLevelElement from './normalizeTopLevelElement';
import { isTopLevel, isLine, } from '..';
import { isFencedCodeBlock } from './utils';
import { makeTopLevelElement, makeLineElement } from '../element-factories';
const opIsSkippable = (editor, op) => {
    if (op.type === 'set_selection') {
        return true;
    }
    if (op.type === 'insert_text' && op.path.length === 3) {
        const topLevelElement = editor.children[op.path[0]];
        if (Element.isElement(topLevelElement) && isTopLevel(topLevelElement)) {
            if (topLevelElement.type === 'code' && topLevelElement.mdastNode) {
                if (isFencedCodeBlock(topLevelElement.mdastNode)) {
                    // TODO: `as Code` seems unnecessary
                    if (op.text.split('').every((c) => c === '`' || c === '~')) {
                        return false;
                    }
                    const row = op.path[1];
                    if (0 < row && row < topLevelElement.children.length - 1) {
                        return true;
                    }
                }
                else {
                    const col = op.offset;
                    if (4 <= col) {
                        return true;
                    }
                }
            }
        }
    }
    else if (op.type === 'remove_text' && op.path.length === 3) {
        const topLevelElement = editor.children[op.path[0]];
        if (Element.isElement(topLevelElement) && isTopLevel(topLevelElement)) {
            if (topLevelElement.type === 'code' && topLevelElement.mdastNode) {
                if (isFencedCodeBlock(topLevelElement.mdastNode)) {
                    // TODO: `as Code` seems unnecessary
                    const row = op.path[1];
                    if (0 < row && row < topLevelElement.children.length - 1) {
                        return true;
                    }
                }
                else {
                    const col = op.offset;
                    if (4 <= col) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};
export const withMarkdownNormalizeNode = (editor, listeners = {}) => {
    const normalizeTopLevelElement = NormalizeTopLevelElement(listeners);
    const { normalizeNode } = editor;
    editor.normalizeNode = (entry) => {
        const [node, path] = entry;
        if (editor.operations.length > 0 &&
            editor.operations.every(opIsSkippable.bind(null, editor))) {
            normalizeNode(entry);
            return;
        }
        if (Editor.isEditor(node)) {
            if (node.children.length === 0) {
                const newChild = makeTopLevelElement('empty', [makeLineElement('')]);
                Transforms.insertNodes(editor, newChild, { at: [0] });
            }
        }
        else if (Element.isElement(node)) {
            if (path.length === 1) {
                if (isTopLevel(node)) {
                    // Top level elements can have only Element[type=line]
                    if (node.children.every((child) => isLine(child))) {
                        // If the top level element is valid (has only lines)
                        if ((node.type === 'empty' || node.type === 'placeholder') &&
                            node.children.length > 1) {
                            // If an empty or placeholder block has more than one lines, split them.
                            Editor.withoutNormalizing(editor, () => {
                                for (let splitIdx = node.children.length - 1; splitIdx > 0; --splitIdx) {
                                    Transforms.splitNodes(editor, { at: [path[0], splitIdx] });
                                }
                            });
                            return;
                        }
                        Editor.withoutNormalizing(editor, () => {
                            normalizeTopLevelElement(node, path[0], editor);
                        });
                    }
                    else {
                        // If the top level element is invalid (has other than line)
                        // The element is normalized by replacing the content with Element[type=line]-s wrapping the existent texts.
                        const elementText = Node.string(node);
                        if (elementText === '') {
                            const replacement = makeTopLevelElement('empty', [
                                makeLineElement(''),
                            ]);
                            Editor.withoutNormalizing(editor, () => {
                                Transforms.removeNodes(editor, { at: path });
                                Transforms.insertNodes(editor, replacement, { at: path });
                            });
                        }
                        else {
                            const newLineElements = elementText
                                .split('\n')
                                .map((lineStr) => makeLineElement(lineStr));
                            const replacement = {
                                ...node,
                                type: node.type,
                                children: newLineElements,
                                flattenedMdastPath: undefined,
                                flattenedMdastAncestors: undefined,
                                mdastNode: undefined,
                                parentMdastNode: undefined,
                            };
                            Editor.withoutNormalizing(editor, () => {
                                Transforms.removeNodes(editor, { at: path });
                                Transforms.insertNodes(editor, replacement, { at: path });
                            });
                        }
                    }
                }
                else {
                    Transforms.removeNodes(editor, { at: path });
                }
            }
            else if (path.length === 2) {
                if (isLine(node)) {
                    // Element[type=line] can have only text nodes
                    if (node.children.some((child) => !Text.isText(child))) {
                        // TODO: Not remove, but migrate
                        Transforms.removeNodes(editor, { at: path });
                    }
                }
                // else {}
                // NOTE: This else clause cannot be reached because the top level normalization
                // ensures the node must be a line if path.length === 2.
            }
        }
        normalizeNode(entry);
    };
    return editor;
};
//# sourceMappingURL=normalizeNode.js.map